import { NotFoundPageNL } from "@pages/NotFoundPage/NotFoundPage"
import type { store } from "@redux/app/store"
import { QueryClient } from "@tanstack/react-query"
import { createRootRouteWithContext, useLocation } from "@tanstack/react-router"
import App from "../App"

export const Route = createRootRouteWithContext<{
	queryClient: QueryClient
	store: typeof store
}>()({
	component: RouteComponent,
	notFoundComponent: NotFoundComponent,
})

function RouteComponent() {
	return (
		<>
			<App />
			{/* <TanStackRouterDevtools  /> */}
		</>
	)
}
function NotFoundComponent() {
	const currentLocation = useLocation().pathname
	return (
		<NotFoundPageNL
			linkTo={currentLocation.includes("/clients") ? `${currentLocation}/..` : "/"}
			labelTo="Go back"
		/>
	)
}
